'use client'

import { useState } from 'react'

export type ResultsFaq = {
  answer: string
  question: string
}

export function ResultsFaqAccordion({
  questions,
}: {
  questions: ResultsFaq[]
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(
    questions.length > 0 ? 0 : null,
  )

  return (
    <div className="flex flex-col">
      {questions.map((question, index) => {
        const isOpen = index === openIndex
        const panelId = `results-faq-panel-${index}`

        return (
          <div
            className="border-b border-[#ECECEF] last:border-b-0"
            key={question.question}
          >
            <button
              aria-controls={panelId}
              aria-expanded={isOpen}
              className="flex w-full items-start justify-between gap-4 py-[18px] text-left outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2563EB] lg:items-center lg:gap-6 lg:py-[26px]"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              type="button"
            >
              <span className="min-w-0 flex-1 text-[16px] font-semibold leading-[21px] tracking-[-0.01em] text-[#0B0B0F] lg:text-[18px] lg:leading-6">
                {question.question}
              </span>
              <span
                aria-hidden="true"
                className="w-[18px] shrink-0 text-center text-[20px] font-normal leading-[21px] text-[#2563EB] lg:w-5 lg:text-2xl lg:leading-6"
              >
                {isOpen ? '−' : '+'}
              </span>
            </button>

            <div
              className={`grid transition-[grid-template-rows,opacity] duration-[750ms] ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none ${
                isOpen
                  ? 'grid-rows-[1fr] opacity-100'
                  : 'grid-rows-[0fr] opacity-0'
              }`}
              id={panelId}
            >
              <div className="overflow-hidden">
                <p className="max-w-[700px] pb-[18px] text-[14px] leading-[21px] text-[#82828B] lg:pb-[26px] lg:text-[15.5px] lg:leading-6">
                  {question.answer}
                </p>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
